import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "IconCheck fas fa-check"
}
const _hoisted_2 = {
  key: 3,
  class: "IconClock fas fa-clock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Редактирование подписантов",
    loading: _ctx.loading,
    "confirm-disabled": _ctx.loading || _ctx.isModalInvalid,
    onCancel: _ctx.onCancel,
    onConfirm: _ctx.onConfirm
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.signers, (signer, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `signer-${i}`,
          class: "flex items-center justify-between mb-3"
        }, [
          (signer.isLawyer)
            ? (_openBlock(), _createBlock(_component_the_select, {
                key: 0,
                class: "w-full",
                placeholder: "Почтовый адрес",
                label: "value",
                "search-by": "value",
                loading: _ctx.state.isWhitelistLoading,
                failed: _ctx.state.isWhitelistFailed,
                value: signer.email,
                "is-invalid": !signer.email,
                disabled: signer.isSigned,
                options: _ctx.state.whitelist,
                onChange: (s) => _ctx.onUpdateWhitelistedSigner(s, i),
                onRefresh: _ctx.loadWhitelist
              }, null, 8, ["loading", "failed", "value", "is-invalid", "disabled", "options", "onChange", "onRefresh"]))
            : (_openBlock(), _createBlock(_component_the_input, {
                key: 1,
                placeholder: "Почтовый адрес",
                value: signer.email,
                "is-invalid": Boolean(_ctx.state.signersValidation[i]),
                "validation-error-str": _ctx.state.signersValidation[i],
                disabled: signer.isSigned,
                "onUpdate:value": (v) => _ctx.onUpdateSigner(v, i)
              }, null, 8, ["value", "is-invalid", "validation-error-str", "disabled", "onUpdate:value"])),
          _createVNode(_component_the_select, {
            class: _normalizeClass(["mx-3 w-full", { 'mt-2': !signer.isLawyer }]),
            value: signer.typeId,
            "onUpdate:value": ($event: any) => ((signer.typeId) = $event),
            placeholder: "Тип подписи",
            "is-invalid": !signer.typeId,
            options: _ctx.D24_TYPES,
            disabled: signer.isSigned,
            onChange: ($event: any) => (_ctx.onChangeType(i))
          }, null, 8, ["class", "value", "onUpdate:value", "is-invalid", "options", "disabled", "onChange"]),
          (signer.isSigned)
            ? (_openBlock(), _createElementBlock("i", _hoisted_1))
            : (_openBlock(), _createElementBlock("i", _hoisted_2))
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["loading", "confirm-disabled", "onCancel", "onConfirm"]))
}